'use strict';function _asyncToGenerator(fn){return function(){var gen=fn.apply(this,arguments);return new Promise(function(resolve,reject){function step(key,arg){try{var info=gen[key](arg);var value=info.value}catch(error){reject(error);return}if(info.done){resolve(value)}else{return Promise.resolve(value).then(function(value){step('next',value)},function(err){step('throw',err)})}}return step('next')})}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError('Cannot call a class as a function')}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError('this hasn\'t been initialised - super() hasn\'t been called')}return call&&(typeof call=='object'||typeof call=='function')?call:self}function _inherits(subClass,superClass){if(typeof superClass!='function'&&superClass!==null){throw new TypeError('Super expression must either be null or a function, not '+typeof superClass)}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:!1,writable:!0,configurable:!0}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass}

const _=require('pulsar-utils/dist-es6/_');
const BaseService=require('../../../dist-es6/client/angularCommon/baseService');

const debounceOptions={
maxWait:3000,
trailing:!0};


const _ExpiredCookieCheckFrequencyMs=10000;let

CookieRefresherService=function(_BaseService){_inherits(CookieRefresherService,_BaseService);
function CookieRefresherService($http,errorHandlers){_classCallCheck(this,CookieRefresherService);var _this=_possibleConstructorReturn(this,
_BaseService.call(this));
_this._$http=$http;
_this._errorHandlers=errorHandlers;
_this.refreshCookie=_.debounce(_this.refreshCookieImmediate.bind(_this),1500,debounceOptions);

setInterval(_asyncToGenerator(function*(){
if(_.exists(errorHandlers.currentUser)){
const res=yield _this.refreshCookieImmediate();
if(res==='unauthorized'){
if(_this.socketService){
_this.socketService.reconnect();
}
errorHandlers.onSessionExpired();
}
}
}),_ExpiredCookieCheckFrequencyMs);return _this;
}CookieRefresherService.prototype.

refreshCookieImmediate=function(){var ref=_asyncToGenerator(function*(){
try{
yield this._$http({
method:'GET',
url:`/cookieRefresher`});

return'ok';
}catch(err){
if(_.get(err,'status')===401){
return'unauthorized';
}else{
console.error(err);

return'errored';
}
}
});function refreshCookieImmediate(){return ref.apply(this,arguments)}return refreshCookieImmediate}();return CookieRefresherService}(BaseService);


module.exports=CookieRefresherService;
//# sourceMappingURL=cookieRefresherService.js.map
